import React, { Component } from 'react';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import { Row, Col, Modal } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import moment from 'moment';
import { PROJECT_LOGO } from '../../constants/constants';
import _branding from 'modules/branding';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { join } from 'lodash';
// Phase E (centralized language resource migration): Text renders this file's page-chrome strings
// from modules/i18n/pages/preview.js (dot-path "preview.*") instead of hardcoded bilingual text.
// The printable receipt payload (#outerBorder/#divReceiptPrint below) is deliberately left untouched
// — see that markup's own Stage 3.5 comment — so only the title/button-row/confirm-Modal chrome
// outside it is migrated; every string used here is a JSX-typed prop/child, so the plain-string
// resolveText() helper is not needed in this file.
import Text from 'components/Text/Text';

class PreviewCandidateDetails_new extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      data: [],
      posts: [],
      loading: true,
      studentPersonalModel: {},
      studentReservationModel: {},
      isLoading: false,
      // Sprint 2.6.2 (Candidate Experience Modernization): confirmation gate before proceeding toward
      // payment — this screen previously had none, unlike Registration_new.jsx's equivalent pre-submit Modal.
      showConfirmModal: false,
    };
  }

  componentDidMount() {
    this.getStudentPersonalData();
  }

  getStudentPersonalData = async () => {
    try {
      this.setState({ loading: true }, async () => {
        try {
          let response = await _StudentService.getStudentReceiptData();
          //debugger
          this.setState({
            data: response.data,
            studentPersonalModel: response.data.studentPersonalModel,
            studentReservationModel: response.data.studentReservationModel,
            loading: false,
          });
        } catch (e) {
          // TODO
          this.setState({ loading: false });
          console.log("Error: ", e);
        }
      });
    } catch (e) { }
  };

  onCancel = () => {
    this.props.onTabOrderChange(-1);
  };

  onPrevious = () => {
    this.props.onTabOrderChange(3);
  };

  onTabOrderChange = () => {
    if (this.props.IsExamPaymentOnline) {
      this.props.onTabOrderChange(5);
    } else {
      this.props.onTabOrderChange(4);
    }
  };

  // Sprint 2.6.2: "Save & Next" now opens a confirmation Modal instead of navigating immediately —
  // this is the step that proceeds toward payment, so it deserves the same confirm-before-proceeding
  // gate Registration_new.jsx already has before its own final submit.
  handleOpenConfirmModal = () => {
    this.setState({ showConfirmModal: true });
  };

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handleConfirmNext = () => {
    this.setState({ showConfirmModal: false }, () => {
      this.onTabOrderChange();
    });
  };

  onPrint = () => {
    this.setState({ isLoading: true });

    // const originalDiv = document.querySelector("#divReceiptPrint");

    // // Clone the div to avoid modifying the original
    // const clonedDiv = originalDiv.cloneNode(true);
    // clonedDiv.style.position = "absolute";
    // clonedDiv.style.left = "-9999px"; // Move it off-screen
    // document.body.appendChild(clonedDiv);

    // html2canvas(clonedDiv, {
    //   scale: window.devicePixelRatio, // Improves quality
    //   allowTaint: true,
    //   useCORS: true,
    // }).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/jpeg", 0.8);

    //   const doc = new jsPDF({
    //           orientation: "p",
    //           unit: "mm",
    //           format: "a4",
    //           compressPdf: true,
    //         });

    //         const pageWidth = 210; // A5 width in mm
    //         const pageHeight = 297;  // A5 height in mm
    //   const imgWidth = pageWidth; // Set image width
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

    //   let yPosition = 0; // Tracks where we are on the page
    //   let remainingHeight = imgHeight; // Remaining content height

    //   while (remainingHeight > 0) {
    //     const cropHeight = Math.min(remainingHeight, pageHeight); // Crop to A5 height or remaining content

    //     doc.addImage(imgData, "JPEG", 0, yPosition * -1, imgWidth, cropHeight);

    //     remainingHeight -= pageHeight; // Reduce the height left to print
    //     yPosition += pageHeight; // Move to next part

    //     if (remainingHeight > 0) {
    //       doc.addPage(); // Add a new page for overflow content
    //     }
    //   }

    //   doc.save("Candidate_Application.pdf");

    //   // Cleanup: Remove cloned div after PDF generation
    //   document.body.removeChild(clonedDiv);
    //   this.setState({ isLoading: false });
    // });

    // this.setState({ isLoading: true });

    const originalDiv = document.querySelector("#divReceiptPrint");

    // Clone the div to avoid modifying the original
    const clonedDiv = originalDiv.cloneNode(true);
    clonedDiv.style.position = "absolute";
    clonedDiv.style.left = "-9999px";
    clonedDiv.style.width = "841.89px";
    document.body.appendChild(clonedDiv);


    html2canvas(clonedDiv, {
      scale: 3, allowTaint: true, useCORS: true
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', 0.8);

      const doc = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        compressPdf: true
      });

      const pageWidth = 595.28;
      const pageHeight = 841.89;

      const margin = 1; // Margin for all sides
      const contentWidth = pageWidth - margin * 2;
      const contentHeight = pageHeight - margin * 2;

      const widthRatio = contentWidth / canvas.width;
      const heightRatio = contentHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);

      const canvasWidth = canvas.width * ratio;
      const canvasHeight = canvas.height * ratio;

      // Center the image within the margins
      const xOffset = margin + (contentWidth - canvasWidth) / 2;
      const yOffset = margin;

      doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
      doc.save(this.buildReceiptFileName());
      document.body.removeChild(clonedDiv);
      this.setState({ isLoading: false });
    });
  };

  // Phase R6.5 (§6): the generic "Candidate_Application.pdf" gave every candidate's download the exact
  // same filename, even though Application_Id/Form_Number/candidate name were already sitting in
  // `this.state.data.studentPersonalModel` unused at this exact point. Built from the same
  // already-fetched data (no new API call), using the Admin-configured exam name already cached at
  // login (AuthService.cachePortalConfiguration -> localStorage['Exam_Name']) instead of hardcoding a
  // tenant-specific name, so this stays correct for any exam this portal is configured for.
  buildReceiptFileName = () => {
    const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    const model = this.state.data.studentPersonalModel || {};
    const examName = sanitize(localStorage['Exam_Name']) || 'Application';
    const applicationId = sanitize(model.Application_Id) || sanitize(model.Form_Number) || 'Unknown';
    const candidateName = sanitize([model.First_Name, model.Middle_Name, model.Last_Name].filter(Boolean).join('_')) || 'Candidate';
    return examName + '_Application_' + applicationId + '_' + candidateName + '.pdf';
  };

  render() {
    if (this.state.loading) return <LoadingSpinner />;

    return (
      <>
        {/* Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): container widened
            (.ch-container -> .ent-container). The printable receipt below (#divReceiptPrint/
            #outerBorder, captured by html2canvas/jspdf) is deliberately left untouched — see
            frontendDesign/Stage_3_5/Implementation/ERPM_S3_5_Implementation_Plan.md. */}
        {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
        <div className="cd-priview gl-bxbr printPage analysisWrap p-4 mt-3  ent-container">
          <h4 className="ch-heading4 mb-3">
            <Text k="preview.pageTitle" />
          </h4>
          <div className="cd-priview-wrap">
            <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2">
              <div
                id="outerBorder"
                style={{
                  textAlign: "center",
                  border: "solid",
                  borderColor: "gray",
                  overflowX: 'auto'
                }}
              >
                <div
                  id="divReceiptPrint"
                  style={{
                    textAlign: "center",
                    border: "solid",
                    borderColor: "transparent",
                    padding: 7,
                    width: '1015px'
                  }}
                >
                  <div>
                    {/* Phase C.7.2 (Branding Foundation): resolved through the unified priority chain
                        (Portal_Logo → branding LogoUrl → PROJECT_LOGO) instead of a hardcoded env-config logo. */}
                    <img
                      alt="PROJECT_LOGO"
                      src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)}
                      className="projectLogoSizeWidth"
                      style={{ alignSelf: "center", cursor: "pointer" }}
                    />
                  </div>

                  <div className="receipt_generation_head">
                    <div
                      style={{
                        fontSize: "25px",
                        fontWeight: "bold",
                        marginTop: "5px",
                        marginBottom: "5px",
                        color: "black",
                        width: "100%"
                      }}
                    >
                      {this.state.data.studentPersonalModel.Applied_Post}
                      {" - "} {"("}
                      {this.state.data.studentPersonalModel.Form_Number}
                      {")"}
                    </div>
                  </div>

                  <div
                    className="receipt_generation_Table2 my-2"
                    style={{ display: "inline-table", width: "100%" }}
                  >
                    <table className="table_100_percent tableHiddenBorder">
                      <tbody>
                        <tr>
                          <td
                            className="table_personal_info"
                            style={{ padding: 0, borderStyle: "hidden" }}
                          >
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "center",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <Text k="preview.personalInfoSectionTitle" />
                                  </td>
                                </tr>
                                <tr>
                                  <th><Text k="preview.fullNameLabel" /></th>

                                  <td>
                                    {this.state.data.studentPersonalModel
                                      .First_Name +
                                      " " +
                                      this.state.data.studentPersonalModel
                                        .Middle_Name +
                                      " " +
                                      this.state.data.studentPersonalModel
                                        .Last_Name}
                                  </td>
                                </tr>
                                <tr style={{ height: "25px" }}>
                                  <th><Text k="preview.fathersNameLabel" /></th>
                                  <td>
                                    {
                                      this.state.data.studentPersonalModel
                                        .Father_Name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th><Text k="preview.mothersNameLabel" /></th>
                                  <td>
                                    {
                                      this.state.data.studentPersonalModel
                                        .Mother_Name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th><Text k="preview.aadhaarNumberLabel" /></th>
                                  <td>
                                    {
                                      this.state.data.studentPersonalModel
                                        .Aadhaar_Number
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th><Text k="preview.emailIdLabel" /></th>
                                  <td>
                                    {this.state.data.studentPersonalModel.Email}
                                  </td>
                                </tr>
                                <tr>
                                  <th><Text k="preview.mobileNoLabel" /></th>
                                  <td>
                                    {
                                      this.state.data.studentPersonalModel
                                        .Mobile_Number
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    <Text k="preview.addressContactInfoLabel" />
                                  </th>
                                  <td style={{ overflowWrap: "anywhere" }}>
                                    <div>
                                      {
                                        this.state.data.studentPersonalModel
                                          .Address
                                      }
                                    </div>
                                    <Text k="preview.villageCityLabel" /> :{" "}
                                    {
                                      this.state.data.studentPersonalModel
                                        .Village
                                    }
                                    , { }
                                    <Text k="preview.talukaLabel" /> :{" "}
                                    {
                                      this.state.data.studentPersonalModel
                                        .Taluka
                                    }
                                    , { }
                                    <Text k="preview.districtLabel" /> :{" "}
                                    {
                                      this.state.data.studentPersonalModel
                                        .District
                                    }
                                    , { }
                                    <Text k="preview.pinCodeLabel" /> :{" "}
                                    {
                                      this.state.data.studentPersonalModel
                                        .Pin_Code
                                    }
                                    , { }
                                    <Text k="preview.stateLabel" /> :{" "}
                                    {this.state.data.studentPersonalModel.State}
                                    , { }
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <label
                                      style={{
                                        marginRight: "17rem",
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span><Text k="preview.genderLabel" /> : </span>
                                      {
                                        this.state.data.studentPersonalModel
                                          .Gender
                                      }
                                    </label>
                                    <label
                                      style={{
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span><Text k="preview.dateOfBirthColonLabel" /> :</span>
                                      {moment(
                                        this.state.data.studentPersonalModel
                                          .Birth_Date
                                      ).format("DD-MMM-YYYY")}
                                    </label>
                                    <br></br>
                                    <label
                                      style={{
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span>
                                        <Text k="preview.maritalStatusLabel" /> :{" "}
                                      </span>
                                      {
                                        this.state.data.studentPersonalModel
                                          .Marital_Status
                                      }
                                    </label>
                                  </td>
                                </tr>
                                {this.state.data.studentPersonalModel
                                  .IsDrivingLicenceMandatory && (
                                    <tr style={{ height: "25px" }}>
                                      <th><Text k="preview.drivingLicenceNoLabel" /></th>
                                      <td>
                                        {
                                          this.state.data.studentPersonalModel
                                            .DrivingLicenceNumber
                                        }
                                      </td>
                                    </tr>
                                  )}

                                <tr>
                                  <td colSpan={2}>
                                    <label
                                      style={{
                                        marginRight: "4rem",
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span>
                                        <Text k="preview.disabilityCategoryNameLabel" />
                                        :{" "}
                                      </span>
                                      {this.state.data.studentPersonalModel.DisabilityCategoryName ?
                                        this.state.data.studentPersonalModel.DisabilityCategoryName
                                        : "N/A"}

                                    </label>
                                    <br />
                                    <label
                                      style={{
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span>
                                        <Text k="preview.isScribeRequiredLabel" /> :{" "}
                                      </span>
                                      {/* {this.state.data.studentPersonalModel.IsScribeRequired === "true" && this.state.data.studentPersonalModel.IsScribeRequired !== "" ?
                                       this.state.data.studentPersonalModel.IsScribeRequired
                                        : "N/A"} */}
                                      {(this.state.data.studentPersonalModel.IsScribeRequired) === true ? 'Yes' : "N/A"}
                                    </label>

                                    <br />
                                    <label
                                      style={{
                                        display: "inline",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span>
                                        <Text k="preview.existingEmployeeLabel" /> :{" "}
                                      </span>
                                      {(this.state.data.studentPersonalModel.Is_KaryalayinKamkaj) === true ? 'Yes' : 'No'}
                                    </label>
                                  </td>
                                </tr>

                                {/* <tr>
                                                                    <th className='width_40_Percent'>Physically Handicaped / शारीरिकदृष्ट्या अपंग</th>
                                                                    <td>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                                                    <th>Is Scribe Required? / लेखनिक आवश्यक आहे?</th>
                                                                    <td>{(this.state.data.studentPersonalModel.IsScribeRequired) === true ? 'Yes' : 'No'}</td>
                                                                </tr> */}
                              </tbody>
                            </table>
                          </td>
                          <td style={{ borderStyle: "hidden" }}>
                            <div>
                              <div className="textAlignCenter">
                                <img
                                  className="receipt_details_profile_img"
                                  src={
                                    this.state.data.studentPersonalModel
                                      .Profile_Pic_Path
                                  }
                                  alt="Profile"
                                />
                              </div>
                              <div className="textAlignCenter">
                                <img
                                  className="receipt_details_signature_img"
                                  src={
                                    this.state.data.studentPersonalModel
                                      .Signature_Path
                                  }
                                  alt="Signature"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table
                      className="table_100_percent"
                      style={{ marginTop: "10px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan={6}
                            style={{ textAlign: "center", fontSize: "16px" }}
                          >
                            <Text k="preview.qualificationSectionTitle" />
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={6}
                            style={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <Text k="preview.educationalDetailsHeading" />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <Text k="preview.educationColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.specialisationColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.boardUniversityColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.yearOfPassingColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.marksPercentColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.classColumnHeader" />
                          </th>
                        </tr>

                        {this.state.data.studentQualificationDetailModels.map(
                          (item, index) => (
                            <tr data-index={index}>
                              <td>{item.Qualification}</td>

                              <td>
                                {item.Specilisation &&
                                  item.Specilisation.trim() === "Other"
                                  ? item.other_specilisation
                                  : item.Specilisation
                                }
                              </td>
                              <td>
                                {item.University_Name === "Other" ||
                                  item.University_Id === null ||
                                  item.University_Id === 0
                                  ? item.Other_Information
                                  : item.University_Name}
                              </td>
                              <td>{item.Passed_Year}</td>
                              <td>{item.Percentage_Grade}</td>
                              <td>{item.Class}</td>
                            </tr>
                          )
                        )}

                        {this.state.data &&
                          this.state.data.otherInformationModel &&
                          this.state.data.otherInformationModel.map(
                            (item, index) => {
                              if (index === 0) {
                                return (
                                  <React.Fragment key={index}>
                                    {console.log(
                                      "item.Is_Marathi_Typing_30",
                                      item.Is_Marathi_Typing_30
                                    )}
                                    <tr>
                                      <td
                                        colSpan={6}
                                        style={{
                                          textAlign: "center",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <Text k="preview.typingSkillHeading" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th colSpan={2}>
                                        <Text k="preview.marathiTyping30Label" />
                                      </th>
                                      <td colSpan={4}>
                                        {item.Is_Marathi_Typing_30 == true
                                          ? "Yes"
                                          : "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th colSpan={2}>
                                        <Text k="preview.englishTyping40Label" />
                                      </th>
                                      <td colSpan={4}>
                                        {item.Is_English_Typing_40 == true
                                          ? "Yes"
                                          : "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        colSpan={6}
                                        style={{
                                          textAlign: "center",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <Text k="preview.shortHandHeading" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th colSpan={2}>
                                        <Text k="preview.wpm100Label" />
                                      </th>
                                      <td colSpan={4}>
                                        {item.Is_100_WPM == true
                                          ? "Yes"
                                          : "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th colSpan={2}>
                                        <Text k="preview.wpm120Label" />
                                      </th>
                                      <td colSpan={4}>
                                        {item.Is_120_WPM == true
                                          ? "Yes"
                                          : "N/A"}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              } else {
                                return null;
                              }
                            }
                          )}

                        <tr>
                          <td
                            colSpan={6}
                            style={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <Text k="preview.workExperienceHeading" />
                          </td>
                        </tr>
                        <tr>
                          <th colSpan={3}>
                            <Text k="preview.organizationNameColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.designationColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.fromDateColumnHeader" />
                          </th>
                          <th>
                            <Text k="preview.toDateColumnHeader" />
                          </th>
                        </tr>

                        {this.state.data.otherInformationModel &&
                          this.state.data.otherInformationModel.map(
                            (item, index) => (
                              <>
                                <tr data-index={index}>
                                  <td colSpan={3}>
                                    {item.Organisation
                                      ? item.Organisation
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {item.Designation
                                      ? item.Designation
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {item && item.From_Date
                                      ? moment(item.From_Date).format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {item && item.To_Date
                                      ? moment(item.To_Date).format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "N/A"}
                                  </td>
                                </tr>
                              </>
                            )
                          )}
                      </tbody>
                    </table>

                    <table
                      className="table_reservation_details"
                      style={{ marginTop: "10px" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan={4}
                            style={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <Text k="preview.feesDetailsHeading" />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={12}>
                            <Row>
                              <Col span={12}>
                                <label
                                  style={{
                                    display: "inline",
                                    fontSize: "14px",
                                  }}
                                >
                                  <span>
                                    <Text k="preview.examinationFeeLabel" /> :{" "}
                                  </span>
                                  {
                                    this.state.data.studentReservationModel
                                      .Exam_Fee
                                  }
                                </label>
                              </Col>
                            </Row>
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td colSpan={4} style={{ textAlign: 'center', fontSize: "14px" }}>
                                                        Reservation / Age Relaxation Details (आरक्षण / वय शिथील तपशील)
                                                    </td>
                                                </tr> */}

                        {/* <tr>
                                                    <th className='width_40_Percent'>Physically Handicaped / शारीरिकदृष्ट्या अपंग</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                                    <th>Is Scribe Required? / लेखनिक आवश्यक आहे?</th>
                                                    <td>{(this.state.data.studentPersonalModel.IsScribeRequired) === true ? 'Yes' : 'No'}</td>
                                                </tr> */}
                        {/* <tr>
                                                    <th>Female / महिला आरक्षण</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Ladies) === true ? 'Yes' : 'No'}</td>
                                                    <th>Ex Serviceman / माजी सैनिक</th>
                                                    <td>{(this.state.data.studentReservationModel.Ex_Serviceman) === true ? 'Yes' : 'No'}</td>

                                                </tr>

                                                <tr>
                                                    <th>Earth Quake Affected / भुकंपग्रस्त</th>
                                                    <td>{(this.state.data.studentReservationModel.Earth_Quake_Affected) === true ? 'Yes' : 'No'}</td>
                                                    <th>Anshkalin / अंशकालीन</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Anshkalin) === true ? 'Yes' : 'No'}</td>

                                                </tr>

                                                <tr>
                                                    <th>Player / खेळाडू</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Player) === true ? 'Yes' : 'No'}</td>
                                                    <th>Project Affected / प्रकल्पग्रस्त</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Praklapgast) === true ? 'Yes' : 'No'}</td>
                                                </tr>

                                                <tr>
                                                    <th>Orphan / अनाथ</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Orphan) === true ? 'Yes' : 'No'}</td>

                                                    <th className='width_40_Percent'>Existing Employee / विद्यमान कर्मचारी</th>
                                                    <td>{(this.state.data.studentPersonalModel.Is_KaryalayinKamkaj) === true ? 'Yes' : 'No'}</td>

                                                </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12">
                <div className="form-action d-flex justify-content-end button-global-group btn3">
                  <div className="btn2-wrap">
                    <ButtonComponent
                      id="btnCancel"
                      type="button"
                      value={
                        <div className="displayInGrid">
                          <Text k="preview.cancel" />
                        </div>
                      }
                      className="button-global button-border mr-4 autoHeight"
                      onClick={this.onCancel}
                    />
                    <ButtonComponent
                      id="btnPrevious"
                      type="button"
                      value={
                        <div className="displayInGrid">
                          <Text k="preview.previous" />
                        </div>
                      }
                      className="button-global button-border mr-4 autoHeight"
                      onClick={this.onPrevious}
                    />
                    <ButtonComponent
                      id="btnSaveNext"
                      type="button"
                      value={
                        <div className="displayInGrid">
                          <Text k="preview.saveNext" />
                        </div>
                      }
                      className="button-global button-primary mr-4 autoHeight"
                      onClick={this.handleOpenConfirmModal}
                    />
                  </div>

                  <ButtonComponent
                    id="btnPrintDownload"
                    type="button"
                    value={
                      <div className="displayInGrid">
                        <Text k="preview.printDownloadApplication" />
                      </div>
                    }
                    // Stage 3.5: migrated off the buggy, 4-way-duplicated .button-secondary (see
                    // frontendDesign/Stage_3_5/Review/ERPM_S3_5_UI_Review.md) onto .button-outline —
                    // fixes this one call site without touching the shared broken rule.
                    className="button-global button-outline autoHeight"
                    onClick={this.onPrint}
                  />
                </div>
              </div>
            </div>
            <Modal
              title={<div className='displayInGrid'><Text k="preview.confirmAndProceed" /></div>}
              visible={this.state.showConfirmModal}
              onCancel={this.handleCloseConfirmModal}
              className="modal-global"
              footer={[
                <ButtonComponent
                  key="cancel"
                  id="btnConfirmModalCancel"
                  type="button"
                  value={<div className='displayInGrid'><Text k="preview.cancel" /></div>}
                  className="button-global button-border mr-2 autoHeight"
                  onClick={this.handleCloseConfirmModal}
                />,
                <ButtonComponent
                  key="confirm"
                  id="btnConfirmModalProceed"
                  type="button"
                  value={<div className='displayInGrid'><Text k="preview.proceed" /></div>}
                  className="button-global button-primary autoHeight"
                  onClick={this.handleConfirmNext}
                />
              ]}
            >
              <Text tag="p" k="preview.reviewBeforeProceeding" />
            </Modal>
          </div>
        </div>
      </>
    );
  }
}

export default PreviewCandidateDetails_new;